import React, { useEffect, useMemo, useState } from 'react';
import { db } from './firebase';
import { doc, getDoc } from 'firebase/firestore';
import { useLocation } from 'react-router-dom';
import Spinner from '../../FrontEnd/Integration/Spinner';
import CardAgendadetails from '../../FrontEnd/Integration/CardAgendadetails';

function FbDetailsGetService() {
  const location = useLocation();

  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  /**
   * Segmentar e decodificar o pathname uma única vez por mudança de rota.
   * Ex.: "/Db/Servicos/Agenda/ABC123" -> ["Db", "Servicos", "Agenda", "ABC123"]
   */
  const segments = useMemo(() => {
    const parts = location.pathname.split('/').filter(Boolean);
    // Decodifica cada segmento com segurança
    return parts.map(seg => {
      try {
        return decodeURIComponent(seg);
      } catch {
        // Se houver erro de decodificação, retorna original
        return seg;
      }
    });
  }, [location.pathname]);

  useEffect(() => {
    let alive = true;

    async function run() {
      setLoading(true);
      setError(null);
      setProduct(null);

      try {
        // Valida raiz "Db"
        console.log(segments)
        if (segments[0] !== 'Agendar') {
          throw new Error('Caminho inválido: a raiz esperada é "Db".');
        }

        // Mínimo para um documento: Db / {collection} / {docId}
        if (segments.length < 3) {
          throw new Error('Caminho insuficiente para localizar o documento.');
        }

        // Um caminho de documento sempre termina em docId, então:
        // Db(0), col(1), doc(2), col(3), doc(4) ... → total de segmentos deve ser ÍMPAR
        if (segments.length % 5 === 0) {
          console.log(segments.length )
          throw new Error('Caminho incompleto: faltou um identificador de documento.');
        }

        // Monta o docRef dinamicamente com todos os segmentos
        const ref = doc(db,`Db/${segments[1]}/${segments[2]}/${segments[3]}`);

        const snap = await getDoc(ref);
        if (!snap.exists()) {
          throw new Error('Documento não encontrado.');
        }

        if (alive) {
          setProduct({ id: snap.id, ...snap.data() });
        }
      } catch (e) {
        console.error('Erro ao carregar detalhes:', e);
        if (alive) setError(e.message || 'Falha ao carregar detalhes.');
      } finally {
        if (alive) setLoading(false);
      }
    }

    run();
    return () => {
      alive = false;
    };
  }, [segments]);

  if (loading) return <Spinner />;
  if (error) return <div className="p-4 text-red-600">{error}</div>;
  if (!product) return <div className="p-4 text-gray-600">Nenhum detalhe encontrado.</div>;

  return <CardAgendadetails {...product} />;
}

export default FbDetailsGetService;